import React, { useCallback, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import FiltersRow from './FiltersRow/FiltersRow';
import { actions } from '../../../../../../context';
import SortIndicator from './SortIndicator';

const TableHead = ({ filteredCodeIds = [] }) => {
    const dispatch = useDispatch();
    const checkboxRef = useRef(null);

    const displayUsageDetails = useSelector(
        (state) => state.daylight.userHasAccessToCodeUsageDetails,
        shallowEqual
    );
    const sortConfig = useSelector(
        (state) => state.daylight.sortConfig,
        shallowEqual
    );

    const onSort = (field) => dispatch(actions.daylight.toggleSort(field));

    const selectedCodeIds = useSelector(
        (state) => state.daylight.selectedCodeIds,
        shallowEqual
    );

    const practiceIsFinalized = useSelector(
        (state) => state.daylight.practiceIsFinalized
    );

    const allSelected = filteredCodeIds.length > 0 && filteredCodeIds.every(id => selectedCodeIds.includes(id));
    const someSelected = selectedCodeIds.length > 0 && !allSelected;

    if (checkboxRef.current) {
        checkboxRef.current.indeterminate = someSelected;
    }

    const handleSelectAll = useCallback(() => {
        if (allSelected) {
            dispatch(actions.daylight.clearCodeSelection());
        } else {
            dispatch(actions.daylight.selectAllFilteredCodes(filteredCodeIds));
        }
    }, [dispatch, allSelected, filteredCodeIds]);

    return (
        <thead>
            <tr className="bg-dark text-light sticky-top">
                {!practiceIsFinalized && (
                    <th scope="col" className="col" style={{ width: '36px', minWidth: '36px' }}>
                        <input
                            ref={checkboxRef}
                            type="checkbox"
                            checked={allSelected}
                            onChange={handleSelectAll}
                            title={allSelected ? 'Deselect all' : 'Select all visible codes'}
                            style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                        />
                    </th>
                )}
                <th scope="col" className="col col-x-small">
                    Row
                </th>
                <th scope="col" className="col col-medium sortable-header" onClick={() => onSort('codeCategory')}>
                    Category<SortIndicator field="codeCategory" sortConfig={sortConfig} />
                </th>
                <th scope="col" className="col col-small sortable-header" onClick={() => onSort('code')}>
                    Code<SortIndicator field="code" sortConfig={sortConfig} />
                </th>
                <th scope="col" className="col col-med-large sortable-header" onClick={() => onSort('codeDescription')}>
                    Description<SortIndicator field="codeDescription" sortConfig={sortConfig} />
                </th>
                <th scope="col" className="text-nowrap col col-small sortable-header" onClick={() => onSort('codePrice')}>
                    <abbr title='Legacy Sale Price'>LSP</abbr><SortIndicator field="codePrice" sortConfig={sortConfig} />
                </th>
                <th scope="col" className="col col-small sortable-header" onClick={() => onSort('locationId')}>
                    Location<SortIndicator field="locationId" sortConfig={sortConfig} />
                </th>
                {displayUsageDetails && (
                    <th scope="col" className="col col-medium sortable-header" onClick={() => onSort('usageDetails')}>
                        Usage Details<SortIndicator field="usageDetails" sortConfig={sortConfig} />
                    </th>
                )}
                <th scope="col" className="col col-small sortable-header" onClick={() => onSort('codeTTM')}>
                    <abbr title='Trailing Twelve Months'>TTM</abbr><SortIndicator field="codeTTM" sortConfig={sortConfig} />
                </th>
                <th scope="col" className="col col-large sortable-header" onClick={() => onSort('mappings')}>
                    Mappings<SortIndicator field="mappings" sortConfig={sortConfig} />
                </th>
                <th scope="col" className="col col-actions">&nbsp;</th>
            </tr>
            <FiltersRow />
        </thead>
    );
};

export default TableHead;
